import { useCallback, useEffect, useMemo, useState } from 'react';
import Results from 'components/Results';
import { ULTIMATE_WEAPONS } from 'utils/constants';
import './main.scss';
import Footer from 'components/Footer';
import { useCheckboxState } from 'utils/hooks';
import ShowAll from 'components/ShowAll';

const DEFAULT_MAP = Object.freeze(
  ULTIMATE_WEAPONS.reduce((unlocked, weapon) => {
    // eslint-disable-next-line no-param-reassign
    unlocked[weapon] = false;
    return unlocked;
  }, {}),
);

const Main = () => {
  const [showAll, setShowAll] = useCheckboxState(false, 'showAllUw');
  const [unlocked, setUnlocked] = useState(DEFAULT_MAP);
  const unlock = useCallback(
    ({ target: { name, checked } }) => {
      setUnlocked(prev => {
        const next = { ...prev };
        next[name] = checked;
        return next;
      });
    },
    [setUnlocked],
  );
  const [choices, setChoices] = useState(DEFAULT_MAP);
  const updateChoices = useCallback(
    ({ target: { name, checked } }) => {
      setChoices(prev => {
        const next = { ...prev };
        next[name] = checked;
        return next;
      });
    },
    [setChoices],
  );
  useEffect(() => {
    setChoices(prev => {
      const next = { ...prev };
      let updated = false;
      Object.entries(unlocked).forEach(([name, checked]) => {
        if (checked && prev[name]) {
          next[name] = false;
          updated = true;
        }
      });
      return updated ? next : prev;
    });
  }, [unlocked]);

  const currentCount = useMemo(
    () =>
      Object.values(unlocked).reduce((count: number, uw) => {
        let newCount = count;
        if (uw) newCount += 1;
        return newCount;
      }, 0),
    [unlocked],
  );

  const choiceCount = useMemo(
    () =>
      Object.values(choices).reduce((count: number, uw) => {
        let newCount = count;
        if (uw) newCount += 1;
        return newCount;
      }, 0),
    [choices],
  );

  return (
    <div id='main'>
      <div className='controls'>
        <input type='checkbox' checked={showAll} onChange={setShowAll} />
        Show All Ultimaye Weapon Info.
      </div>
      {showAll && <ShowAll />}
      {!showAll && (
        <>
          <div className='selector'>
            <div className='title'>
              What Ultimaye Weapons do you currently own?
            </div>
            {ULTIMATE_WEAPONS.map(uw => (
              <div className='uw-choice' key={uw}>
                <input
                  type='checkbox'
                  name={uw}
                  checked={unlocked[uw]}
                  onChange={unlock}
                />
                {uw}
              </div>
            ))}
          </div>
          {currentCount < 9 && (
            <div className='selector'>
              <div className='title'>
                What Ultimaye Weapons can you pick from (enter them all)?
              </div>
              {ULTIMATE_WEAPONS.map(
                uw =>
                  !unlocked[uw] && (
                    <div className='uw-choice' key={uw}>
                      <input
                        type='checkbox'
                        name={uw}
                        disabled={
                          unlocked[uw] || (choiceCount === 3 && !choices[uw])
                        }
                        checked={choices[uw]}
                        onChange={updateChoices}
                      />
                      {uw}
                    </div>
                  ),
              )}
            </div>
          )}
          {currentCount === 9 && (
            <div className='please-select'>
              Congrats you have everything. For UW+, hopefully at this point you
              have the common sense to know where your build lacks and what it
              needs. GT+ for economy, ILM+, SM+, and SL+ for waves, CF+ for
              chips, CL+ for rays and protectors. Join the discord for better
              info on how to optimize them.
            </div>
          )}
          {choiceCount === 3 || currentCount + choiceCount >= 9 ? (
            <Results
              unlocked={unlocked}
              choices={choices}
              currentCount={currentCount}
            />
          ) : (
            <div className='please-select'>Please select all your choices</div>
          )}
        </>
      )}
      <Footer />
    </div>
  );
};

export default Main;
